var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_vm._m(0),_c('hr'),_c('Registration')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"block","width":"100%","text-align":"center"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"alt":"BeamNG.tech logo","src":require("./assets/logo.png")}})])
}]

export { render, staticRenderFns }